export const SIGNALR_BRIDGE_MESSAGES = {
  // From parent to iframe
  CONNECT: 'CONNECT',
  SUBSCRIBE: 'SUBSCRIBE',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  INVOKE: 'INVOKE',
  DISCONNECT: 'DISCONNECT',

  // From iframe to parent
  READY: 'READY',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  RECONNECTING: 'RECONNECTING',
  MESSAGE: 'MESSAGE',
  INVOKE_RESULT: 'INVOKE_RESULT',
  INVOKE_ERROR: 'INVOKE_ERROR',
  ERROR: 'ERROR',
} as const;

export type SignalRBridgeMessageType =
  (typeof SIGNALR_BRIDGE_MESSAGES)[keyof typeof SIGNALR_BRIDGE_MESSAGES];

export interface SignalRBridgeMessage {
  type: SignalRBridgeMessageType;
  data?: unknown;
  method?: string;
  args?: unknown[];
  error?: string;
  id?: string;
  result?: unknown;
}
